import type { MediaDto } from '@/queries/media/media.schema';
import type { ProgressStatusDto } from '@/queries/progress-statuses/progress-statuses.schema';
import { ProgressStatusAppearance } from '@/queries/progress-statuses/progress-statuses.enum';
import { buildCloudflareMediaUrl } from '@/utils/images/cloudflareLoader';

export const getProgressStatusAssetMedia = (
  status: ProgressStatusDto,
  appearance: ProgressStatusAppearance,
): MediaDto | undefined => {
  return status.assets?.find(asset => asset.appearance === appearance)?.media;
};

export const getProgressStatusIconMedia = (status: ProgressStatusDto) => {
  return getProgressStatusAssetMedia(status, ProgressStatusAppearance.ICON);
};

export const getProgressStatusMediaSrc = (media: MediaDto) => {
  return media.key ?? media.path;
};

export const getProgressStatusMediaUrl = (media: MediaDto) => {
  return buildCloudflareMediaUrl(getProgressStatusMediaSrc(media));
};

export const getProgressStatusVideoUrl = (media: MediaDto) => {
  return buildCloudflareMediaUrl(getProgressStatusMediaSrc(media));
};

export const getStatusImagePath = (status: ProgressStatusDto) => {
  const iconMedia = getProgressStatusIconMedia(status);

  return iconMedia ? getProgressStatusMediaSrc(iconMedia) : '';
};
